/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<44114e18df895b8c098db65c82ac1fb5>>
 *
 * Generated by LanguageCLDRGenScript
 *
 * 
 */
'use strict';

var IntlVariations = require("./IntlVariations");

var IntlCLDRNumberType42 = {
  getVariation: function getVariation(n) {
    return IntlVariations.NUMBER_OTHER;
  }
};
module.exports = IntlCLDRNumberType42;